import { useEffect, useState } from "react";
import dayjs from "dayjs";
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import img from "../images/modalimage.svg";

import { string } from "yup";
import { OnboardingModel } from "../../model/OnboardingModel";
import { useGlobalState } from "../../services/context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { FormikValues, useFormik } from "formik";
import { OnboardigSchema } from "../../validations/Schema";
import { UtilService } from "../../services/shared/UtilService";
import { msgTypes } from "../../constants/msgTypes";
import { UserRegisterService } from "../../services/UserRegisterService";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import { branchList } from "../../constants/constant";
import MuiUploader from "../../components/basicComponent/MuiUploader";
import MuiButton from "../../components/basicComponent/MuiButton";
import { head } from "axios";
type List = {
  label: string;
  value: string;
};
type CreateCorporateProps = {
  data?: OnboardingModel;
  logo?: string;
  heading?: string;
};
const CreateCorporate = ({ data, heading, logo }: CreateCorporateProps) => {
  const { token } = useGlobalState();
  const navigate = useNavigate();
  const location = useLocation();
  const isEdit = location?.state?.isEdit;
  const [currencyCodeList, setCurrencyCodeList] = useState([]);

  const [stateList, setStateList] = useState<List[]>([]);
  const [cityList, setCityList] = useState<List[]>([]);
  const [tradeLicense, setTradeLicense] = useState<string>();
  const [emiratesDoc, setEmiratesDoc] = useState<string>();
  const [corporateLogo, setCorporateLogo] = useState<string>();

  const [countryList, setCountryList] = useState<List[]>([]);
  const [phone, setPhone] = useState("");
  useEffect(() => {
    getCountry();
  }, []);

  const formik = useFormik({
    initialValues: new OnboardingModel(data),
    validationSchema: OnboardigSchema,
    onSubmit(values, formikHelpers) {
      if (!isEdit && typeof token === "string") {
        saveRegistration(values);
      } else if (isEdit && !!token) {
        editRegistration(values);
      } else {
        saveRegistrationAfterLogin(values);
      }
    },
  });

  const getCountry = async () => {
    const response = await UtilService.getCountry();
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      const arr = response?.data?.map(
        (i: { countryName: any; countryId: any }) => ({
          id: i?.countryId,
          label: i?.countryName,
          value: i?.countryName,
        })
      );
      setCountryList(arr);
    }
  };

  const getState = async (countryId: string) => {
    const id = !!countryId ? countryId : formik.values.countryId;
    const response = await UtilService.getState(id);
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      const arr = response?.data?.map(
        (i: { statesName: any; statesId: any }) => ({
          id: i?.statesId,
          label: i?.statesName,
          value: i?.statesName,
        })
      );

      setStateList(arr);
    }
  };

  const getCity = async (stateId: string) => {
    const id = !!stateId ? stateId : formik.values.statesId;
    const response = await UtilService.getCity(id);
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      const arr = response?.data?.map((i: { cityName: any; cityId: any }) => ({
        id: i?.cityId,
        label: i?.cityName,
        value: i?.cityName,
      }));
      setCityList(arr);
    }
  };

  // if (!!formik.values.statesId) {
  //   getCity(formik.values.statesId);
  // }
  const saveRegistration = async (values: FormikValues) => {
    const requestData = { ...values };
    const response = await UserRegisterService.saveRegistration(requestData);
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      navigate("/corporatelist");
      formik.resetForm();
    }
  };
  const editRegistration = async (values: FormikValues) => {
    const requestData = { ...values };
    const response = await UserRegisterService.editRegistration(requestData);
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      navigate("/corporatelist");
    }
  };

  const saveRegistrationAfterLogin = async (values: FormikValues) => {
    const requestData = { ...values };
    const response = await UserRegisterService.saveRegistrationAfterLogin(
      requestData
    );
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      navigate("/corporatelist");
      formik.resetForm();
    }
  };

  const typeList = [
    { label: "Default", value: "Default" },
    {
      label: "B2E- Travel Co-Ordinator",
      value: "B2E- Travel Co-Ordinator",
    },
    {
      label: "CBT-Employee Booking",
      value: "CBT-Employee Booking",
    },
  ];

  const titleList = [
    { label: "Mr.", value: "Mr." },
    { label: "Mrs.", value: "Mrs." },
    { label: "Miss.", value: "Miss." },
  ];

  const handleFileUpload = (uploadedFileUrl: string | null) => {
    if (!uploadedFileUrl) {
      formik.setFieldError("documentProofTradeLicense", "File upload failed.");
    } else {
      formik.setFieldValue("documentProofTradeLicense", uploadedFileUrl);
      formik.setFieldError("documentProofTradeLicense", "");
    }
  };
  const handleEmirateDoc = (uploadedFileUrl: string | null) => {
    if (!uploadedFileUrl) {
      formik.setFieldError("documentProofEmirates", "File upload failed.");
    } else {
      formik.setFieldValue("documentProofEmirates", uploadedFileUrl);
      formik.setFieldError("documentProofEmirates", "");
    }
  };
  const   handleCorporateDoc = (uploadedFileUrl: string | null) => {
    if (!uploadedFileUrl) {
      formik.setFieldError("corporateLogo", "File upload failed.");
    } else {
      formik.setFieldValue("corporateLogo", uploadedFileUrl);
      formik.setFieldError("corporateLogo", "");
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    navigate("/");
  };
 
  console.log("err", formik.errors);
  return (
    <>
      <div className="card">
        {!!logo && (
          <div className="onboard-logo">
            <img src={logo} alt="logo" />
          </div>
        )}
        {!!heading && <h3 className="card-title ">{heading}</h3>}
        <div className="card-body flex flex-col justify-end items-stretch grow  py-1 mt-5">
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiInput
                placeholder="Enter Business Name"
                label={"Business Name"}
                isRequired={true}
                isInvalid={
                  formik.touched.businessName &&
                  Boolean(formik.errors.businessName)
                }
                errorText={
                  formik.touched.businessName && formik.errors.businessName
                    ? formik.errors.businessName
                    : ""
                }
                onChange={(e) => formik.setFieldValue("businessName", e)}
                onBlur={() => formik.setFieldTouched("businessName", true)}
                value={formik.values.businessName}
              />
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiDropDown
                placeholder="Select Branch"
                onChange={(value: string) =>
                  formik.setFieldValue("branch", value)
                }
                onBlur={() => formik.setFieldTouched("branch", true)}
                options={branchList}
                label="Branch"
                value={formik.values.branch}
                isRequired={true}
                errorText={
                  formik.touched.branch && formik.errors.branch
                    ? formik.errors.branch
                    : ""
                }
                isInvalid={
                  formik.touched.branch && Boolean(formik.errors.branch)
                }
              />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiDropDown
                placeholder="Select Type"
                onChange={(value: string) =>
                  formik.setFieldValue("type", value)
                }
                onBlur={() => formik.setFieldTouched("type", true)}
                options={typeList}
                label="Type"
                value={formik.values.type}
                isRequired={true}
                errorText={
                  formik.touched.type && formik.errors.type
                    ? formik.errors.type
                    : ""
                }
                isInvalid={formik.touched.type && Boolean(formik.errors.type)}
              />
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiDropDown
                placeholder="Select Title"
                onChange={(value: string) =>
                  formik.setFieldValue("title", value)
                }
                onBlur={() => formik.setFieldTouched("title", true)}
                options={titleList}
                label="Title"
                value={formik.values.title}
                isRequired={true}
                errorText={
                  formik.touched.title && formik.errors.title
                    ? formik.errors.title
                    : ""
                }
                isInvalid={formik.touched.title && Boolean(formik.errors.title)}
              />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiInput
                placeholder="Enter First Name"
                label="First Name"
                isRequired={true}
                isInvalid={
                  formik.touched.firstName && Boolean(formik.errors.firstName)
                }
                errorText={
                  formik.touched.firstName && formik.errors.firstName
                    ? formik.errors.firstName
                    : ""
                }
                onChange={(e) => formik.setFieldValue("firstName", e)}
                onBlur={() => formik.setFieldTouched("firstName", true)}
                value={formik.values.firstName}
              />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiInput
                placeholder="Enter Last Name"
                label="Last Name"
                isRequired={true}
                isInvalid={
                  formik.touched.lastName && Boolean(formik.errors.lastName)
                }
                errorText={
                  formik.touched.lastName && formik.errors.lastName
                    ? formik.errors.lastName
                    : ""
                }
                onChange={(e) => formik.setFieldValue("lastName", e)}
                onBlur={() => formik.setFieldTouched("lastName", true)}
                value={formik.values.lastName}
              />
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiInput
                placeholder="Enter Mobile Number"
                label="Mobile Number"
                isRequired={true}
                isInvalid={
                  formik.touched.mobileNo && Boolean(formik.errors.mobileNo)
                }
                errorText={
                  formik.touched.mobileNo && formik.errors.mobileNo
                    ? formik.errors.mobileNo
                    : ""
                }
                onChange={(e) => formik.setFieldValue("mobileNo", e)}
                onBlur={() => formik.setFieldTouched("mobileNo", true)}
                value={formik.values.mobileNo}
                slotProps={{
                  htmlInput: {
                    maxLength: 10,
                  },
                }}
              />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiInput
                placeholder="Enter Email"
                label="First Email"
                isRequired={true}
                isInvalid={
                  formik.touched.emailId && Boolean(formik.errors.emailId)
                }
                errorText={
                  formik.touched.emailId && formik.errors.emailId
                    ? formik.errors.emailId
                    : ""
                }
                onChange={(e) => formik.setFieldValue("emailId", e)}
                onBlur={() => formik.setFieldTouched("emailId", true)}
                value={formik.values.emailId}
              />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiInput
                placeholder="Enter Alternate Email Id"
                label="Email ID (Alternate)"
                isRequired={true}
                isInvalid={
                  formik.touched.alternateEmailId &&
                  Boolean(formik.errors.alternateEmailId)
                }
                errorText={
                  formik.touched.alternateEmailId &&
                  formik.errors.alternateEmailId
                    ? formik.errors.alternateEmailId
                    : ""
                }
                onChange={(e) => formik.setFieldValue("alternateEmailId", e)}
                onBlur={() => formik.setFieldTouched("alternateEmailId", true)}
                value={formik.values.alternateEmailId}
              />
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiInput
                placeholder="Enter Address"
                label="Address"
                isRequired={true}
                isInvalid={
                  formik.touched.address && Boolean(formik.errors.address)
                }
                errorText={
                  formik.touched.address && formik.errors.address
                    ? formik.errors.address
                    : ""
                }
                onChange={(e) => formik.setFieldValue("address", e)}
                onBlur={() => formik.setFieldTouched("address", true)}
                value={formik.values.address}
              />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiInput
                placeholder="Enter Phone Number"
                label="Phone Number"
                isRequired={true}
                isInvalid={
                  formik.touched.phoneNo && Boolean(formik.errors.phoneNo)
                }
                errorText={
                  formik.touched.phoneNo && formik.errors.phoneNo
                    ? formik.errors.phoneNo
                    : ""
                }
                onChange={(e) => formik.setFieldValue("phoneNo", e)}
                onBlur={() => formik.setFieldTouched("phoneNo", true)}
                value={formik.values.phoneNo}
              />
            </div>
            {/* <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                <MuiDatePicker
                  label="Date of Joining"
                  value={
                    formik.values.dateOfJoining
                      ? dayjs(formik.values.dateOfJoining)
                      : null
                  }
                  onChange={(date: string) => {
                    formik.setFieldValue("dateOfJoining", date);
                  }}
                  isError={
                    formik.touched.dateOfJoining &&
                    Boolean(formik.errors.dateOfJoining)
                  }
                  errorText={
                    formik.touched.dateOfJoining
                      ? formik.errors.dateOfJoining
                      : ""
                  }
                />
              </div> */}

            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiDropDown
                placeholder="Select Country"
                onChange={(value: string, id: any) => {
                  formik.setFieldValue("countryName", value);
                  formik.setFieldValue("countryId", id);
                  !!id && getState(id);
                }}
                onBlur={() => formik.setFieldTouched("countryName", true)}
                options={countryList}
                label="Country"
                value={formik.values.countryName}
                isRequired={true}
                errorText={
                  formik.touched.countryName && formik.errors.countryName
                    ? formik.errors.countryName
                    : ""
                }
                isInvalid={
                  formik.touched.countryName &&
                  Boolean(formik.errors.countryName)
                }
              />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiDropDown
                placeholder="Select State"
                onChange={(value: string, id: any) => {
                  formik.setFieldValue("statesName", value);
                  formik.setFieldValue("statesId", id);
                  getCity(id);
                }}
                onBlur={() => formik.setFieldTouched("statesName", true)}
                options={stateList}
                label="State"
                value={formik.values.statesName}
                isRequired={true}
                errorText={
                  formik.touched.statesName && formik.errors.statesName
                    ? formik.errors.statesName
                    : ""
                }
                isInvalid={
                  formik.touched.statesName && Boolean(formik.errors.statesName)
                }
              />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiDropDown
                placeholder="Select City"
                onChange={(value: string, id: any) => {
                  formik.setFieldValue("city", value);
                  formik.setFieldValue("cityId", id);
                }}
                onBlur={() => formik.setFieldTouched("city", true)}
                options={cityList}
                label="City"
                value={formik.values.city}
                isRequired={true}
                errorText={
                  formik.touched.city && formik.errors.city
                    ? formik.errors.city
                    : ""
                }
                isInvalid={formik.touched.city && Boolean(formik.errors.city)}
              />
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
              <MuiInput
                placeholder="Enter Postal Code"
                label="Postal Code"
                isRequired={true}
                isInvalid={
                  formik.touched.postalCode && Boolean(formik.errors.postalCode)
                }
                errorText={
                  formik.touched.postalCode && formik.errors.postalCode
                    ? formik.errors.postalCode
                    : ""
                }
                onChange={(e) => formik.setFieldValue("postalCode", e)}
                onBlur={() => formik.setFieldTouched("postalCode", true)}
                value={formik.values.postalCode}
              />
            </div>
         

            <div className="col-md-4">
              <MuiUploader
                label="Trade License"
                name="documentProofTradeLicense"
                values={formik.values.documentProofTradeLicense}
                errors={
                  formik.touched.documentProofTradeLicense &&
                  formik.errors.documentProofTradeLicense
                    ? formik.errors.documentProofTradeLicense
                    : ""
                }
                onFileUpload={handleFileUpload}
              />
            </div>
            <div className="col-md-4">
              <MuiUploader
                label="Emirates"
                name="documentProofEmirates"
                values={formik.values.documentProofEmirates}
                errors={
                  formik.touched.documentProofEmirates &&
                  formik.errors.documentProofEmirates
                    ? formik.errors.documentProofEmirates
                    : ""
                }
                onFileUpload={handleEmirateDoc}
              />
            </div>
            <div className="col-md-4">
              <MuiUploader
                label="Corporate Logo"
                name="corporateLogo"
                values={formik.values.corporateLogo}
                errors={
                  formik.touched.corporateLogo && formik.errors.corporateLogo
                    ? formik.errors.corporateLogo
                    : ""
                }
                onFileUpload={handleCorporateDoc}
              />
            </div>

            {/* <div className="row mb-4 onboarding-uploader">
               
              </div> */}

            <div className="pb-2 user-button w-full text-end onboard-btn">
              <MuiButton
                className="main-clear-btn"
                label="Clear"
                type="submit"
                onClick={() => formik.resetForm()}
              />
              <MuiButton
                label="submit"
                type="submit"
                // disabled={!formik.dirty || !form/ik.isValid}
                variant="outlined"
                onClick={() => formik.handleSubmit()}
                fullWidth={false}
                className="main-btn"
              />
            </div>

            {/* <React.Fragment>
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <DialogActions>
                      <Button onClick={handleClose} autoFocus>
                        <i className="ki-filled ki-cross  menu-item-show:inline-flex large-iconn"></i>
                      </Button>
                    </DialogActions>
                    <div className="d-flex justify-center mb-2">
                      <div className="flex justify-center items-center size-14 shrink-0 rounded-full ring-1 ring-gray-300 bg-gray-100">
                        <i className="ki-filled ki-sms text-2xl "></i>
                      </div>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 text-center">
                      Check your email
                    </h3>
                    <div className="text-2sm text-center text-gray-700 mb-7.5">
                      Please click the link sent to your email
                      <a
                        className="text-2sm text-gray-800 font-medium hover:text-primary-active"
                        href="#"
                      >
                        bob@reui.io
                      </a>
                      <br />
                      to reset your password. Thank you
                    </div>
                    <div
                      className="flex justify-center db-btn"
                      onClick={() => handleClose()}
                    >
                      <a className="btn  flex justify-center " href="">
                        OK
                      </a>
                    </div>
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </React.Fragment> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateCorporate;
